import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageAssignmentComponent } from './manage-assignment/manage-assignment.component';
import { MaterialModule } from '../material.module';
import { MatTabsModule } from '@angular/material/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ManageTaskComponent } from './manage-task/manage-task.component';
import { ManageBranchComponent } from './manage-branch/manage-branch.component';
import { ManageFinancialYearComponent } from './manage-financial-year/manage-financial-year.component';
import { ManageDRoleComponent } from './manage-d-role/manage-d-role.component';
import { ManageDesignationComponent } from './manage-designation/manage-designation.component';
import { ManageLocationComponent } from './manage-location/manage-location.component';
import { ManageClientComponent } from './manage-client/manage-client.component';
import { ServiceVerticalComponent } from './service-vertical/service-vertical.component';

@NgModule({
  declarations: [ManageAssignmentComponent, ManageTaskComponent, ManageBranchComponent, ManageFinancialYearComponent, ManageDRoleComponent, ManageDesignationComponent, ManageLocationComponent, ManageClientComponent, ServiceVerticalComponent],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class MasterDataModule { }
